<template>
  <v-app>
    <v-main>
      <logout class="noprint" />
      <v-container v-if="loading" fill-height grid-list-md text-center ghost>
        <v-row wrap align-center>
          <v-col>
            Computation progress...
            <v-progress-linear
              color="light-blue accent-4"
              indeterminate
              rounded
              height="6"
            ></v-progress-linear>
          </v-col>
        </v-row>
      </v-container>
      <v-container ghost v-else>
        <iol-result-header :fields="results_header" />
        <v-sheet
          :class="currentSide ? 'iol-right-v-sheet' : 'iol-left-v-sheet'"
        >
          <h2 :align="currentSide ? 'left' : 'right'">
            {{ currentSide ? 'OD' : 'OS' }}
          </h2>
          <v-row>
            <v-col class="col-12 col-md-6" :order-sm="currentSide ? '1' : '2'">
              <iol-result-used-param class="col-12" :fields="common_inputs" />
              <v-row>
                <iol-result-switch-history
                  class="col-2 col-md-2"
                  :fields="switch_hist"
                />
                <iol-result-corn-ref-surg
                  class="col-10 col-md-10"
                  :fields="corneal_history"
                />
              </v-row>
            </v-col>
            <v-col class="col-12 col-md-6" :order-sm="currentSide ? '2' : '1'">
              <iol-result-used-param :fields="common_inputs_cont" />
              <v-row>
                <iol-result-switch-history
                  class="col-2 col-md-2"
                  :fields="switch_hist"
                />
                <iol-result-corn-ref-surg
                  class="col-10 col-md-10"
                  :fields="corneal_history_cont"
                />
              </v-row>
            </v-col>
          </v-row>
          <v-row class="justify-space-between">
            <v-col cols="12" md="6" :order-sm="currentSide ? '1' : '2'">
              <iol-data-table-power :fields="results_table" />
            </v-col>
            <v-col cols="12" md="6" :order-sm="currentSide ? '2' : '1'">
              <v-simple-table
                class="iol-results"
                style="background-color: #c4c4c4 !important"
              >
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th>IOL POWER (D)</th>
                      <th>REFRACTION (D)</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>{{ controlateralResults.pm1.power }}</td>
                      <td>{{ controlateralResults.pm1.es }}</td>
                    </tr>
                    <tr>
                      <td>{{ controlateralResults.pm05.power }}</td>
                      <td>{{ controlateralResults.pm05.es }}</td>
                    </tr>
                    <tr>
                      <td>{{ controlateralResults.p0.power }}</td>
                      <td>{{ controlateralResults.p0.es }}</td>
                    </tr>
                    <tr>
                      <td>{{ controlateralResults.p05.power }}</td>
                      <td>{{ controlateralResults.p05.es }}</td>
                    </tr>
                    <tr>
                      <td>{{ controlateralResults.p1.power }}</td>
                      <td>{{ controlateralResults.p1.es }}</td>
                    </tr>
                  </tbody>
                  <tfoot>
                    <tr>
                      <td colspan="2">
                        Without Second Eye Mode - for information
                      </td>
                    </tr>
                  </tfoot>
                </template>
              </v-simple-table>
            </v-col>
          </v-row>
        </v-sheet>
        <div class="noprint">
          <v-row>
            <v-col cols="12" class="text-center gray">
              <a @click="print" :style="resetstyle">Print</a>
            </v-col>
          </v-row>
          <br />
          <v-row>
            <v-col cols="12" class="text-center">
              <v-btn to="/second" color="#3B4256" class="white--text" x-large
                >Modify Calculation</v-btn
              >
            </v-col>
            <v-col cols="12" class="text-center">
              <v-btn
                @click="submit_toric"
                color="#3B4256"
                class="white--text"
                :disabled="results_table.selected_power == null"
                x-large
              >
                Toric Calculation
              </v-btn>
            </v-col>
          </v-row>
        </div>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import { mapState } from 'vuex'

import Logout from '@/vue/Logout.vue'
import IolDataTablePower from '@/components/results/IolDataTablePower.vue'
import IolResultHeader from '@/components/results/IolResultHeader.vue'
import IolResultCornRefSurg from '@/components/results/IolResultCornRefSurg.vue'
import IolResultUsedParam from '@/components/results/IolResultUsedParam.vue'
import IolSwitchField from '@/components/elementary/IolSwitchField.vue'
import IolResultSwitchHistory from '@/components/results/IolResultSwitchHistory.vue'

export default {
  name: 'Result',
  components: {
    Logout,
    IolResultHeader,
    IolDataTablePower,
    IolResultCornRefSurg,
    IolResultUsedParam,
    IolSwitchField,
    IolResultSwitchHistory,
  },
  data() {
    return {
      resetstyle: { color: '#838383' },
      loading: true,
      results_header: {
        title: 'PEARL-DGS - Results - Second Eyes',
        patientID: {
          label: 'Patient ID / Name',
          readonly: true,
          tooltip: '',
          text: '',
        },
        keratometric_index: {
          label: 'Keratometric Index',
          readonly: true,
          tooltip: '',
          text: '',
        },
        biometer: {
          label: 'biometer',
          readonly: true,
          tooltip: '',
          text: '',
        },
      },
      common_inputs: {
        al: '',
        k1: '',
        k2: '',
        acd: '',
        aconst_title: 'A Constant',
        aconst: '',
        target_title: 'Target refraction',
        target: '',
        lt: '',
        cct: '',
        inputs_type: 'second',
      },
      common_inputs_cont: {
        al: '',
        k1: '',
        k2: '',
        acd: '',
        aconst_title: 'Implanted A constant',
        aconst: '',
        se2_title: 'Postop. spherical equivalent',
        se2: '',
        power2_title: 'Implanted IOL power',
        power2: '',
        lt: '',
        cct: '',
        inputs_type: 'controlateral',
        is_outlined: true,
      },
      switch_hist: {
        is_rk: null,
        is_icl: false,
        is_non_physio_cornea: null,
      },
      corneal_history: {
        is_corneal_laser: false,
        corneal_laser_type: '',
        pre_lvc_arc: '',
        laser_amount: '',
      },
      corneal_history_cont: {
        is_corneal_laser: false,
        corneal_laser_type: '',
        pre_lvc_arc: '',
        laser_amount: '',
      },
      results_table: {
        selected: [],
        selected_power: null,
        selected_es: null,
        headers: [
          { text: 'IOL POWER (D)', value: 'power' },
          { text: 'REFRACTION (D)', value: 'es' },
        ],
        powers: [
          {
            id: 0,
            name: 'pm1',
            es: 'espm1',
            power: 'powerpm1',
          },
          {
            id: 1,
            name: 'pm05',
            es: 'espm05',
            power: 'powerpm05',
          },
          {
            id: 2,
            name: 'p0',
            es: 'esp0',
            power: 'powerp0',
          },
          {
            id: 3,
            name: 'p05',
            es: 'esp05',
            power: 'powerp05',
          },
          {
            id: 4,
            name: 'p1',
            es: 'esp1',
            power: 'powerp1',
          },
        ],
      },
    }
  },
  mounted() {
    setTimeout(() => {
      this.loading = false
    }, 2000)

    const inputs = this.currentInputs
    const results = this.currentResults

    // init patient/kera/biom
    this.results_header.patientID.text = inputs.patientID
    this.results_header.keratometric_index.text = inputs.keratometric_index
    this.results_header.biometer.text = inputs.biometer.text

    // init common inputs
    this.common_inputs.al = inputs.al
    this.common_inputs.k1 = inputs.k1
    this.common_inputs.k2 = inputs.k2
    this.common_inputs.acd = inputs.acd
    this.common_inputs.aconst = inputs.aconst
    this.common_inputs.target = inputs.target
    this.common_inputs.lt = inputs.lt
    this.common_inputs.cct = inputs.cct

    // init common inputs controlateral
    this.common_inputs_cont.al = inputs.al2
    this.common_inputs_cont.k1 = inputs.k12
    this.common_inputs_cont.k2 = inputs.k22
    this.common_inputs_cont.acd = inputs.acd2
    this.common_inputs_cont.aconst = inputs.aconst
    this.common_inputs_cont.lt = inputs.lt2
    this.common_inputs_cont.cct = inputs.cct2
    this.common_inputs_cont.se2 = inputs.se2
    this.common_inputs_cont.power2 = inputs.power2

    // init icl
    this.switch_hist.is_icl = inputs.is_icl

    // init corneal history
    this.corneal_history.is_corneal_laser = inputs.is_corneal_laser
    this.corneal_history.corneal_laser_type = inputs.corneal_laser_type.text
    this.corneal_history.pre_lvc_arc = inputs.pre_lvc_arc
    this.corneal_history.laser_amount = inputs.laser_amount

    // init corneal history controlateral
    this.corneal_history_cont.is_corneal_laser = inputs.is_corneal_laser
    this.corneal_history_cont.corneal_laser_type = inputs.corneal_laser_type.text
    this.corneal_history_cont.pre_lvc_arc = inputs.pre_lvc_arc2
    this.corneal_history_cont.laser_amount = inputs.laser_amount2

    // init result table
    this.results_table.powers.forEach((power) => {
      const resultData = results[power.name]
      if (resultData) {
        power.es = resultData.es
        power.power = resultData.power
      }
    })
  },
  computed: {
    ...mapState(['results', 'results2', 'ginputs', 'ginputs2', 'appHeader', 'currentSide']),
    // Get the correct inputs based on which eye was calculated
    currentInputs() {
      return this.currentSide ? this.ginputs : this.ginputs2
    },
    // Get the correct results based on which eye was calculated
    currentResults() {
      return this.currentSide ? this.results : this.results2
    },
    // Get the controlateral results
    controlateralResults() {
      return this.currentSide ? this.results2 : this.results
    },
  },
  methods: {
    print() {
      window.print()
    },
    submit_toric() {
      this.$store.dispatch('updateInputsToric', this.results_table)
      this.$store.dispatch('updateToricCalcAllowed', true)
      this.$router.push('toric')
    },
  },
}
</script>
